import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldlayoutsSchemesConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-fieldlayouts-schemes-config',
	path: '/secure/admin/ConfigureFieldLayoutScheme([!%]?[\\w]*).jspa',
};
